<bw-action-card-legacy [cardConfig]="actionCardConfig"></bw-action-card-legacy>
